import { combineReducers } from 'redux';
import slides from './slides';

const gameApp = combineReducers({
  slides
})

export default gameApp



// WEBPACK FOOTER //
// ./src/reducers/index.js